// extracted by mini-css-extract-plugin
export default {"loader":"pages_common_loader__N21cS"};